export default __webpack_public_path__ + "static/media/machineHack-logo.fafcdaaf.jpg";